import { FC } from 'react'

import cn from 'classnames'

import RabbitIcon from './icons/rabbit.svg'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

interface Props {
  className?: string
  text?: string
  item?: string
}

const NoItemFoot: FC<Props> = ({ className, item, text }) => {
  const { t, replacePlaceholders } = useTranslation()

  return (
    <div className={cn(className, styles.wrapper)}>
      <img src={RabbitIcon} alt="Rabbit icon" />
      {text ? <p>{text}</p> : <p>{replacePlaceholders(t('no_item'), { item })}</p>}
    </div>
  )
}

export default NoItemFoot
